import { ActionTree, MutationTree } from 'vuex'
import _get from 'lodash/get'
import _map from 'lodash/map'
import instance from '../connection'

class State {
  devices: IDevice[] = []
  total: number = 0
  pagination = {
    current: 1 as number,
    pageSize: 10 as number,
    total: 0 as number
  }
  sorter = {
    field: '' as string,
    order: '' as string
  }
  search: string = ''
  currentDevice: string = ''
  employees = []
  employeePagination = {
    current: 1 as number,
    pageSize: 10 as number,
    total: 0 as number
  }
  targetEmployee: {key: string, title: string, description: string}[] = []
  organization: string | undefined = undefined
}

const getters = {
  //
}

const actions = <ActionTree<State, any>>{
  async getDevices({ commit, state }) {
    let params: any = {
      page: state.pagination.current,
      limit: state.pagination.pageSize,
      sort: state.sorter.field,
      order: state.sorter.order,
      search: state.search
    }
    if (state.organization) {
      params.org = state.organization
    }
    commit('updateDevices', await instance.get('/device', { params }))
  },
  async deleteDevice({ dispatch }, id) {
    await instance.delete('/device/' + id)
    return await dispatch('getDevices')
  },
  async updateDevice({ dispatch }, device:any) {
    await instance.put('/device/' + device.id, device)
    return await dispatch('getDevices')
  },
  async addDevice({ dispatch }, device:any) {
    await instance.post('/device', device)
    return await dispatch('getDevices')
  },
  async getDeviceEmployee({ commit, state }, all: boolean = false) {
    if (!all) {
      return commit('updateDeviceEmployee', await instance.get('/device/' + state.currentDevice + '/employee', {
        params: {
          page: state.employeePagination.current,
          limit: state.employeePagination.pageSize,
        }
      }))
    }
    else {
      const result = await instance.get('/device/' + state.currentDevice + '/employee')
      const employees = _map(_get(result, 'data', []), obj => obj.id)
      return commit('updateTargetEmployee', employees)
    }
  },
  async updateDeviceEmployee({ state }) {
    await instance.patch('/device/' + state.currentDevice + '/employee', state.targetEmployee)
  },
  async updateAction(ctx: any, {id, action}) {
    await instance.post('/device/' + id + '/action', {
      action
    })
  },
  async updateServerPath({ state }, serverPath) {
    await instance.post('/device/' + state.currentDevice + '/serverPath', {
      serverPath
    })
  }
}

const mutations = <MutationTree<State>>{
  updateDevices(state, records) {
    state.devices = records.data
    state.total = records.total
    state.pagination.total = records.total
  },
  updateDevicePagination(state, {current, pageSize, total}) {
    if (current) state.pagination.current = current
    if (pageSize) state.pagination.pageSize = pageSize
    if (total) state.pagination.total = total
  },
  updateDeviceSorter(state, {field, order}) {
    if (field) state.sorter.field = field
    if (order) state.sorter.order = order
  },
  updateCurrentDevice(state, deviceId) {
    state.currentDevice = deviceId
  },
  updateDeviceEmployee(state, employees) {
    state.employees = _get(employees, 'data', [])
    state.employeePagination.total = _get(employees, 'total', 0)
  },
  updateTargetEmployee(state, employees) {
    state.targetEmployee = employees
  },
  updateDeviceEmployeePagination(state, {current, pageSize, total}) {
    if (current) state.employeePagination.current = current
    if (pageSize) state.employeePagination.pageSize = pageSize
    if (total) state.employeePagination.total = total
  },
  updateDeviceSearchKey(state, search) {
    state.search = search
  },
  updateCurrentDeviceOrg(state, organization) {
    state.organization = organization
  }
}

interface IDevice {
  name: string
  deviceKey: string
}

export default {
  state: new State(),
  getters,
  actions,
  mutations
}